import React, {useState} from 'react';
import './a.scss';
import {PopUp} from "../co";
import {useQuery, widthStore} from "../../../stores/util";
import {Tool} from "../../../Config/Tool";

export const popAvatar = {};
const A = ({i, act, onClick}) => {
    return <div onClick={() => onClick(i)} className={'ava-' + i + (act ? ' act' : '')}/>
}
export const PopAva = widthStore(({
                                      userStore: {avatar}
                                  }) => {
    const [set, ld] = useQuery('setUserInfo')
    const [v, vv] = useState(avatar);
    const [a, aa] = useState(0);
    const o = i => <A onClick={vv} i={i} act={v === i}/>
    return <PopUp
        cls={'ava'}
        act={a}
        close={() => aa(0)}
        open={() => aa(1)}
        onShow={() => vv(avatar)}
        read={o => Object.assign(popAvatar, o)}>
        <div className={'ava-ls'}>
            <div className={'t'}>更换头像</div>
            <div className={'x'} onClick={() => popAvatar.hide()}>X</div>
            <div className={'ls'}>
                {o(0)}
                {o(1)}
                {o(2)}
                {o(3)}
                {o(4)}
                {o(5)}
                {o(6)}
                {o(7)}
            </div>
            <div className={'btn'} onClick={ld ? null : () => set({avatar: v}, () => {
                popAvatar.hide()
                Tool.alert('已更新个人信息!');
            })}>{ld ? '提交中' : '确定'}</div>
        </div>
    </PopUp>
})
